import { gql, useMutation } from '@apollo/client'

import {
  LikeDocumentMutation as LikeDocumentMutationData,
  LikeDocumentMutationVariables,
  UseLikeDocument_DocumentFragment,
} from './__generated__/use-like-document.graphql'

export const LikeDocumentMutation = gql`
  mutation likeDocument($input: LikeDocumentInput!) {
    likeDocument(input: $input) {
      document {
        id
        viewerLiked
      }
    }
  }
`

export type UseLikeDocumentProps = {
  document: UseLikeDocument_DocumentFragment
  vote: string
}

export type UseLikeDocumentReturn = {
  loading: boolean
  likeDocument: () => Promise<void>
}

export function useLikeDocument({ document, vote }: UseLikeDocumentProps): UseLikeDocumentReturn {
  const { docId, artifact } = document
  const [mutate, { loading }] = useMutation<
    LikeDocumentMutationData,
    LikeDocumentMutationVariables
  >(LikeDocumentMutation, {
    update(cache, { data: mutate }) {
      cache.modify({
        id: cache.identify(document),
        fields: {
          viewerLiked() {
            return mutate?.likeDocument?.document?.viewerLiked
          },
        },
      })
    },
  })

  return {
    async likeDocument() {
      const input = { docId, artifact, vote }
      await mutate({ variables: { input } })
    },
    loading,
  }
}

useLikeDocument.fragments = {
  document: gql`
    fragment UseLikeDocument_document on Document {
      id
      docId
      artifact
    }
  `,
}
